import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExamMLResult} from "types/ExamMLRestult";

export interface ExamMLResultState {
  currentExamMLResult: ExamMLResult;
  loading: boolean;
}

const initialState: ExamMLResultState = {
  currentExamMLResult: {} as ExamMLResult,
  loading: false,
};

export const examMLResultSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setMinMaxFrames: (state, action: PayloadAction<ExamMLResult>) => {
      state.currentExamMLResult = action.payload;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setMinMaxFrames,
  setLoading
} = examMLResultSlice.actions;
export const { reducer } = examMLResultSlice;
